import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Error: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 6h2v7h-2V6zM13.5 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.66 17.577V6.423L12 .845 2.34 6.423v11.154L12 23.155l9.66-5.578zm-17.32-10L12 3.155l7.66 4.422v8.846L12 20.845l-7.66-4.422V7.577z"
        fill={color}
      />
    </svg>
  );
};

export default Error;
